import React, { Suspense, useEffect } from "react"
import { RouteFallback } from "components/new-stuff/layout/RouteFallback"
import { App, Layout } from "antd"
import { useState } from "react"
import { useAuthStore } from "stores"
import { Outlet } from "react-router-dom"
import { SideNavigationBar } from "./SideNavigationBar"
import { TopNavigationBar } from "./TopNavigationBar"
import { NotificationBar } from "./NotificationBar"
import { isPadeDomain } from "utils/utils"
import Intercom from "@intercom/messenger-js-sdk"

const { Header, Content } = Layout

const SuspendedExitedEmployeeLayout: React.FC = () => {
  const { user } = useAuthStore()
  const [isSidebarOpen, toggleSidebar] = useState(false)

  const { isAuthenticated, signOut } = useAuthStore((state) => state)

  useEffect(() => {
    if (!isAuthenticated) {
      signOut(true)
    }
  }, [isAuthenticated])

  isPadeDomain() === true &&
    Intercom({
      app_id: "bi604cch",
      user_id: user?.userId?.toString() || undefined,
      name: user?.userFullName,
      email: user?.userName,
    })

  return (
    <App
      notification={{
        placement: "topRight",
      }}
    >
      <Layout>
        <SideNavigationBar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        <Layout>
          <Header className="bg-white p-0 sticky top-0 z-10 w-full border-b md:pl-[var(--sidenav-w)] transition-[padding-left] duration-300 ease-in-out motion-reduce:transition-none h-[70px]">
            <TopNavigationBar
              isSidebarOpen={isSidebarOpen}
              toggleSidebar={toggleSidebar}
            />
          </Header>
          <Content className=" ">
            <div className="bg-[#F3F5FB] min-h-[100dvh] md:pl-[var(--sidenav-w)] transition-[padding-left] duration-300 ease-in-out motion-reduce:transition-none font-avenir employee__layout">
              <Suspense fallback={<RouteFallback />}>
                <Outlet />
              </Suspense>
              {/* <Dashboard /> */}
            </div>
          </Content>
        </Layout>
      </Layout>

      <NotificationBar />
    </App>
  )
}

export default SuspendedExitedEmployeeLayout

